module.exports = "pegasus/assets/two-column-text-image-one-column-text-preview.png";